export default "__VITE_ASSET__BpWErwv0__"